import { ReactNode } from 'react'

import { StyledList, StyledListItem, ZenkakuSpace } from '../TextStyle'

export const imgItems: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <h3>1. License</h3>
        <p>
          TRIAL Group grants the User a non-exclusive license to use the Images within the scope of the methods and conditions specified in this Policy.
        </p>
      </>
    ),
    id: 'policy1',
  },
  {
    children: (
      <>
        <h3>2. Ownership of Rights</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            The copyright and moral rights related to the Images belong to the TRIAL Group. 
          </StyledListItem>
          <StyledListItem listType="article">
            The Images are licensed under the conditions specified in this Policy, and the TRIAL Group retains the right to license the use of the Images even after granting such license.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy2',
  },
  {
    children: (
      <>
        <h3>3. Conditions of Use</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            The Images may be used to create articles featuring TRIAL Group topics in newspapers, television, magazines, online media (including individually operated ones). 
          </StyledListItem>
          <StyledListItem listType="article">
            The Images can only be used by the individual who downloaded them.
          </StyledListItem>
          <StyledListItem listType="article">
            Unless specified in Article 4, the Images may be modified for use. 
          </StyledListItem>
          <StyledListItem listType="article">
            TRIAL Group reserves the right to refuse permission for the use of the Images.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy3',
  },
  {
    children: (
      <>
        <h3>4. Prohibited Actions</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            It is prohibited to distribute (sell, lease, provide for free, lend, etc.) the Images, as they are or modified, as independent trade items, whether for profit or non-profit. Additionally, any use that obstructs TRIAL Group&apos;s operations is not allowed.
          </StyledListItem>
          <StyledListItem listType="article">
            It is not permissible to use the Images, with or without modifications, as the main content of a product, including any secondary creations, or for any other secondary use.
          </StyledListItem>
          <StyledListItem listType="article">
            It is not allowed to incorporate the Images, with or without modifications, into services provided to third parties (such as internet greeting card services, template download services, use as a mobile phone wallpaper, use in applications as material samples, use as screensavers, etc.).
          </StyledListItem>
          <StyledListItem listType="article">
            It is not permitted to engage in print services or any other service with the purpose of providing the Images to third parties, regardless of modifications.
          </StyledListItem>
          <StyledListItem listType="article">
            Even if the purpose is to provide to business partners, the user cannot grant third parties the right to use the Images. Additionally, transferring, leasing, or lending the Images to third parties is not allowed.
          </StyledListItem>
          <StyledListItem listType="article">
            Using the Images as a trademark, trade name, or in any other way for product representation or registration is not allowed.
          </StyledListItem>
          <StyledListItem listType="article">
            Providing the Images to other stock photo services is not allowed.
          </StyledListItem>
          <StyledListItem listType="article">
            Using the Images in a manner contrary to public order and morality, or for purposes related to activities or business practices contrary to public order and morality, or engaging in antisocial activities or practices, is not allowed.
          </StyledListItem>
          <StyledListItem listType="article">
            It is not allowed to use the Images in a way that may violate laws, engage in illegal activities, or involve false or defamatory use. Additionally, using the Images in content such as articles, videos, advertisements, or promotions that may pose a risk of containing these types of content is not permitted. The copyright and moral rights related to the Images belong to the TRIAL Group.
          </StyledListItem>
          <StyledListItem listType="article">
            Use of the Images is not allowed in contexts related to adult content (R18), adult entertainment, explicit sexual content, religion, drugs, strikes, demonstrations, rebellious groups, drugs, nightlife services, or dating services (marriage activities, matching, dating information, online opposite-sex introduction businesses, and other services judged by the TRIAL Group to be related to dating services).
          </StyledListItem>
          <StyledListItem listType="article">
            Use of the Images in a manner that may damage the dignity, reputation, or credibility of the TRIAL Group, or any other manner that may hinder the operation of the TRIAL Group, is not allowed.
          </StyledListItem>
          <StyledListItem listType="article">
            Use of the Images and the model&apos;s dignity, reputation, or credibility in a manner that may damage them, or any other use involving aggressive, discriminatory, sexual, or extreme content is not permitted.
          </StyledListItem>
          <StyledListItem listType="article">
            Use of the Images in a manner that may damage the dignity, reputation, or credibility of third parties, or any other manner that may cause inconvenience to third parties, is not allowed.
          </StyledListItem>
          <StyledListItem listType="article">
            Use of the Images in a way that infringes on intellectual property rights such as copyright and trademark rights, property rights, privacy rights, publicity rights, or portrait rights, or any use that may infringe on these rights, is not allowed.
          </StyledListItem>
          <StyledListItem listType="article">
            Impersonating the Images or using them in a manner that could involve false information (such as introduction photos of individuals or groups, introduction photos of products or goods, introduction photos of buildings or facilities, etc., but not limited to these) is not allowed.
          </StyledListItem>
          <StyledListItem listType="article">
            Directly calling the URL of the Images to display them on other pages and using them in a way that imposes a burden on TRIAL Group servers is not allowed. （17）Any other use that the TRIAL Group deems inappropriate is not allowed.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy4',
  },
  {
    children: (
      <>
        <h3>5. Disclaimer</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            TRIAL Group does not provide any warranty for the Images.
          </StyledListItem>
          <StyledListItem listType="article">
            TRIAL Group is not responsible for any direct, indirect, special, incidental, consequential, or other damages, including but not limited to data loss, business interruption, loss of profits, mental distress, etc., arising from the use or inability to use the Images.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy5',
  },
  {
    children: (
      <>
        <h3>6. Suspension of Use</h3>
        <p>
          If the user violates any provision of this agreement, TRIAL Group can immediately demand the user to cease using the Images and delete them. In such a case, the user must promptly discard, eliminate, or delete all copies of the Images.
        </p>
      </>
    ),
    id: 'policy6',
  },
  {
    children: (
      <>
        <h3>7. Compensation for Damages</h3>
        <p>
          If the user causes damages to TRIAL Group due to actions violating this agreement, the user is obligated to compensate TRIAL Group for the damages.
        </p>
      </>
    ),
    id: 'policy7',
  },
  {
    children: (
      <>
        <h3>8. Amendment of Terms</h3>
        <p>
          TRIAL Group may modify, add, or abolish all or part of these terms without prior notice. In such cases, TRIAL Group shall not be responsible for any damage or loss incurred by users due to these modifications, additions, or abolitions.
        </p>
      </>
    ),
    id: 'policy8',
  },
  {
    children: (
      <>
        <h3>9. Governing Law and Jurisdiction</h3>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            These terms are governed by Japanese law and will be interpreted in accordance with Japanese law.
          </StyledListItem>
          <StyledListItem listType="article">
            In the event of any dispute related to these terms, the exclusive jurisdictional court shall be the court with jurisdiction over the location of the head office of TRIAL Holdings, Inc.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'policy9',
  },
  {
    children: (
      <>
        <p>
          Date of Enactment:
          <ZenkakuSpace />
          December 26,2022
        </p>
      </>
    ),
    id: 'policy10',
  },
]

export const imgLinks: {
  name: string
  anchor: string
}[][] = [
  [
    {
      name: '（License）',
      anchor: 'policy1',
    },
    {
      name: '（Ownership of Rights）',
      anchor: 'policy2',
    },
    {
      name: '（Conditions of Use）',
      anchor: 'policy3',
    },
  ],
  [
    {
      name: '（Prohibited Actions）',
      anchor: 'policy4',
    },
    {
      name: '（Disclaimer）',
      anchor: 'policy5',
    },
    {
      name: '（Suspension of Use）',
      anchor: 'policy6',
    },
  ],
  [
    {
      name: '（Compensation for Damages）',
      anchor: 'policy7',
    },
    {
      name: '（Amendment of Terms）',
      anchor: 'policy8',
    },
    {
      name: '（Governing Law and Jurisdiction）',
      anchor: 'policy9',
    },
  ],
]
